module.exports = __webpack_public_path__ + "img/prize-05.bbe94630.png";